import * as resorts from './idsResorts';
import { WINTER, SUMMER } from '../types/typesSeasons';

export const ROUTE_WINTER_OVERVIEW = 'overview';
export const ROUTE_WINTER_GW = 'grindelwald-wengen';
export const ROUTE_WINTER_GF = 'grindelwald-first';
export const ROUTE_WINTER_MS = 'muerren-schilthorn';

export const ROUTE_SUMMER_OVERVIEW = 'overview';
export const ROUTE_SUMMER_JR = 'jungfrau-region';
export const ROUTE_SUMMER_KS = 'kleine-scheidegg';
export const ROUTE_SUMMER_GF = 'grindelwald-first';

export const ROUTE_TERMINAL_WINTER_GL = 'grindelwald-lauterbrunnen';
export const ROUTE_TERMINAL_WINTER_FW = 'first-wengen';

export const ROUTE_ID_MAPPING_WEB = {
    [WINTER]: {
        [ROUTE_WINTER_OVERVIEW]: resorts.WINTER_OVERVIEW,
        [ROUTE_WINTER_GW]: resorts.WINTER_GW,
        [ROUTE_WINTER_GF]: resorts.WINTER_GF,
        [ROUTE_WINTER_MS]: resorts.WINTER_MS,
    },
    [SUMMER]: {
        [ROUTE_SUMMER_OVERVIEW]: resorts.WINTER_OVERVIEW,
        [ROUTE_SUMMER_JR]: resorts.SUMMER_JR,
        [ROUTE_SUMMER_KS]: resorts.SUMMER_KS,
        [ROUTE_SUMMER_GF]: resorts.SUMMER_GF,
    },
};

export const ROUTE_ID_MAPPING_TERMINAL = {
    [WINTER]: {
        [ROUTE_WINTER_GW]: resorts.WINTER_GW,
        [ROUTE_WINTER_GF]: resorts.WINTER_GF,
        [ROUTE_WINTER_MS]: resorts.WINTER_MS,
        [ROUTE_TERMINAL_WINTER_GL]: resorts.TERMINAL_WINTER_GL,
        [ROUTE_TERMINAL_WINTER_FW]: resorts.TERMINAL_WINTER_FW,
    },
    [SUMMER]: {
        [ROUTE_SUMMER_KS]: resorts.SUMMER_KS,
        [ROUTE_SUMMER_JR]: resorts.SUMMER_JR,
        [ROUTE_SUMMER_GF]: resorts.SUMMER_GF,
    },
};
